/* Gecko Creationz 2026 v2 — motion + small helpers (draft theme). No libraries.
   Everything is scroll-checked (not bound once), so it keeps working even if the
   theme re-renders sections after load. */
(function () {
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
  doc.classList.add('js-g');

  function splitWords(el) {
    if (el.dataset.gSplit) return; el.dataset.gSplit = '1';
    if (el.children.length) { el.classList.add('g-reveal'); return; } /* has a hand-drawn mark: fade it in whole */
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var o = document.createElement('span'); o.className = 'g-line'; o.style.setProperty('--i', i);
      var n = document.createElement('span'); n.textContent = w; o.appendChild(n); el.appendChild(o);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  function countUp(el) {
    if (el.dataset.gDone) return; el.dataset.gDone = '1';
    var raw = el.dataset.gCount || '0', end = parseFloat(raw), dec = (raw.split('.')[1] || '').length;
    var pre = el.dataset.gPrefix || '', suf = el.dataset.gSuffix || '';
    if (reduce || isNaN(end)) { el.textContent = pre + raw + suf; return; }
    var t0 = null;
    (function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + (end * e).toFixed(dec) + suf; if (p < 1) requestAnimationFrame(step); })(performance.now());
  }

  function pinned(vh) {
    document.querySelectorAll('[data-g-pin]').forEach(function (root) {
      var steps = root.querySelectorAll('.g-pin__step'); if (!steps.length) return;
      var mid = vh / 2, best = 0, bestD = Infinity;
      steps.forEach(function (s, k) { var r = s.getBoundingClientRect(); var d = Math.abs(r.top + r.height / 2 - mid); if (d < bestD) { bestD = d; best = k; } });
      if (root.dataset.gOn === String(best)) return; root.dataset.gOn = best;
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === best); });
      root.querySelectorAll('.g-pin__stage > [data-i]').forEach(function (m, k) { m.classList.toggle('is-on', k === best); });
      root.querySelectorAll('.g-pin__progress i').forEach(function (b, k) { b.style.width = k <= best ? '100%' : '0'; });
    });
  }

  var ticking = false;
  function tick() {
    ticking = false;
    var vh = window.innerHeight;
    doc.classList.toggle('g-scrolled', window.scrollY > 40);
    document.querySelectorAll('.g-split:not([data-g-split])').forEach(splitWords);
    document.querySelectorAll('.g-reveal:not(.is-in), .g-stagger:not(.is-in), .g-split:not(.is-in), .g-wipe:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (reduce || (r.top < vh * 0.9 && r.bottom > 0)) el.classList.add('is-in');
    });
    document.querySelectorAll('[data-g-count]:not([data-g-done])').forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.top < vh * 0.85 && r.bottom > 0) countUp(el);
    });
    if (!reduce) document.querySelectorAll('.g-parallax').forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return;
      el.style.setProperty('--g-py', (((r.top + r.height / 2 - vh / 2) / vh) * -40).toFixed(1) + 'px');
    });
    pinned(vh);
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll);
  /* safety net: keep checking while anything is still waiting to appear */
  var guard = setInterval(function () {
    if (!document.querySelector('.g-reveal:not(.is-in), .g-stagger:not(.is-in), .g-split:not(.is-in), .g-wipe:not(.is-in), [data-g-count]:not([data-g-done])')) { clearInterval(guard); return; }
    onScroll();
  }, 700);

  /* delegated: big-type range list hover image (desktop mouse only) */
  var fl = null, raf = null, x = 0, y = 0, tx = 0, ty = 0;
  function loop() { x += (tx - x) * .16; y += (ty - y) * .16; if (fl) fl.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) rotate(-3deg)'; raf = requestAnimationFrame(loop); }
  if (fine) {
    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest && e.target.closest('.g-range__link'); if (!a) return;
      var root = a.closest('[data-g-range]'); fl = root && root.querySelector('.g-range__float'); if (!fl) return;
      var links = Array.prototype.slice.call(root.querySelectorAll('.g-range__link')), i = links.indexOf(a);
      fl.querySelectorAll('img').forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      fl.classList.add('is-on'); if (!raf && !reduce) raf = requestAnimationFrame(loop);
    });
    document.addEventListener('mousemove', function (e) {
      if (!fl) return; var root = fl.closest('[data-g-range]'); var r = root.getBoundingClientRect();
      tx = r.width * 0.56; ty = e.clientY - r.top - fl.offsetHeight / 2;
      if (reduce) fl.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)';
    });
    document.addEventListener('mouseout', function (e) {
      if (!fl) return; var root = fl.closest('[data-g-range]');
      if (!e.relatedTarget || !root.contains(e.relatedTarget) || !e.relatedTarget.closest('.g-range__list')) { fl.classList.remove('is-on'); }
    });
  }

  /* delegated: product rail arrows + mouse drag */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-g-prev],[data-g-next]'); if (!b) return;
    var rail = b.closest('[data-g-rail]').querySelector('.g-rail'); var c = rail.children[0];
    var w = c ? c.getBoundingClientRect().width + 20 : 300;
    rail.scrollBy({ left: b.hasAttribute('data-g-prev') ? -w : w, behavior: reduce ? 'auto' : 'smooth' });
  });
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return; var rail = e.target.closest && e.target.closest('.g-rail'); if (!rail) return;
    drag = { rail: rail, x: e.clientX, sl: rail.scrollLeft, moved: false }; rail.classList.add('is-dragging');
  });
  document.addEventListener('pointermove', function (e) { if (!drag) return; var d = e.clientX - drag.x; if (Math.abs(d) > 5) drag.moved = true; drag.rail.scrollLeft = drag.sl - d; });
  document.addEventListener('pointerup', function () { if (!drag) return; var r = drag.rail; r.classList.remove('is-dragging'); if (drag.moved) { r.dataset.gJustDragged = '1'; setTimeout(function () { delete r.dataset.gJustDragged; }, 50); } drag = null; });
  document.addEventListener('click', function (e) { var r = e.target.closest && e.target.closest('.g-rail'); if (r && r.dataset.gJustDragged) { e.preventDefault(); e.stopPropagation(); } }, true);

  function start() { onScroll(); setTimeout(onScroll, 400); setTimeout(onScroll, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* "Choose your free balm" pop-up: separate files, loaded after the page (bump v when you change them) */
(function () {
  var me = document.currentScript || document.querySelector('script[src*="gecko-2026.js"]'); if (!me || !me.src) return;
  var base = me.src.split('?')[0].replace('gecko-2026.js', ''), v = '8';
  var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = base + 'gecko-free-balm.css?v=' + v; document.head.appendChild(l);
  var s = document.createElement('script'); s.src = base + 'gecko-free-balm.js?v=' + v; s.defer = true; document.head.appendChild(s);
})();
